import { render, staticRenderFns } from "./Annotation.vue?vue&type=template&id=44f69f06&scoped=true&"
import script from "./Annotation.vue?vue&type=script&lang=js&"
export * from "./Annotation.vue?vue&type=script&lang=js&"
import style0 from "./Annotation.vue?vue&type=style&index=0&id=44f69f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f69f06",
  null
  
)

export default component.exports